import React from 'react'

export default function Background(props) {
    let bg_image = {};
    let part = props.part;
    if(part['media']['background'] && part['media']['background']['path']) {
        bg_image = {backgroundImage: `url(${part['media']['background']['path']})`};
    }
    if (part['video']) {
        bg_image = {backgroundImage: `url(https://img.youtube.com/vi/${part['video']}/maxresdefault.jpg)` };
    }
    let bg_video = '';
    if(part['media']['background-video'] && part['media']['background-video']['path']) {
        bg_video = part['media']['background-video']['path'];
    }
    
    return (
        <div className="bg-media">
            {
                bg_image &&
                    <div className={`bg-image ${part['bg_attachment']}`} style={bg_image}>
                    </div>
            }
            {
                bg_video &&
                    <div className="bg-video cover-video">
                        <video preload="auto" src={bg_video} loop autoplay muted></video>
                    </div>
            } 
        </div>
    )
}
